import { DashboardRoutes } from "@/router";
import { Outlet, useLocation } from "react-router-dom";
import NavigationLayout from "@/components/NavigationLayout";
import { DetectMobileView } from "@/router/DetectMobileView";
import { dashboardRoutesArray } from "@/router/constant";
import SaleMenu from "@/components/SideMenus/SaleMenu";
import { useMemo } from "react";

const MobileMySaleWrapper = () => {
  const location = useLocation();
  const memoDashboardRoutesArray = useMemo(() => dashboardRoutesArray(), []);
  const currentUrlObj = memoDashboardRoutesArray.find((i) => i.url === location.pathname);

  const mainMenu = <SaleMenu />;

  const subMenus = (
    <NavigationLayout
      menu={mainMenu}
      mobileBackNavigation={DashboardRoutes.mySale.root.url}
      mobileTitle={currentUrlObj?.meta?.translation || ""}
    >
      <Outlet />
    </NavigationLayout>
  );

  return location.pathname === DashboardRoutes.mySale.root.url ? mainMenu : subMenus;
};

const DesktopMySaleWrapper = () => (
  <NavigationLayout menu={<SaleMenu />}>
    <Outlet />
  </NavigationLayout>
);

const MySaleRoot = () => <DetectMobileView mobile={<MobileMySaleWrapper />} desktop={<DesktopMySaleWrapper />} />;

export default MySaleRoot;
